import React from "react"
import Img from "gatsby-image"
import { Link } from "gatsby"
import { useHeaderBackgroundQuery } from "hooks/useHeaderBackgroundQuery"
import { useInstagramQuery } from "hooks/useInstagramQuery"

const Footer = ({ data }) => {
  const backgroundImage = useHeaderBackgroundQuery()
  const instagramImage = useInstagramQuery()
  return (
    <div
      class="shadow-sm"
      style={{ position: "fixed", width: "100%", bottom: "0", zIndex: "1" }}
    >
      <Img fluid={backgroundImage} style={{ minHeight: "65px" }} />
      <div
        class="d-flex justify-content-center"
        style={{
          position: "absolute",
          top: "0",
          height: "100%",
          width: "100%",
        }}
      >
        <div
          class="p-2"
          onClick={() =>
            window.open(
              "https://www.instagram.com/your.onkel.tattoo/",
              "_blank"
            )
          }
        >
          <Img fixed={instagramImage} />
        </div>
      </div>
    </div>
  )
}

export default Footer
